import { useEffect, useState } from "react";
import { useGameStore } from "../../store/gameStore";
import { Input } from "../ui/input";
import { Sparkles } from "lucide-react";

// GM-only floating control that appears the moment a player trips a trap/obstacle check, letting
// the GM nudge the upcoming roll up or down (a good plea, a lucky circumstance, etc.) BEFORE the
// player rolls. The adjustment is relayed live over the room's websocket and folded into the
// player's roll the instant they hit Roll.
export default function ObstacleModifierBar({ isGm, sendWs }) {
  const pending = useGameStore((s) => s.pendingObstacleTrigger);
  const setPending = useGameStore((s) => s.setPendingObstacleTrigger);
  const [modifier, setModifier] = useState(0);

  useEffect(() => setModifier(pending?.gm_modifier || 0), [pending?.obstacle_id, pending?.member_id]);

  if (!isGm || !pending) return null;

  const apply = (value) => {
    const clamped = Number.isFinite(value) ? value : 0;
    setModifier(clamped);
    setPending({ ...pending, gm_modifier: clamped });
    sendWs({ type: "obstacle_modifier_set", data: { obstacle_id: pending.obstacle_id, member_id: pending.member_id, modifier: clamped } });
  };

  return (
    <div className="absolute top-4 left-1/2 -translate-x-1/2 z-30 flex items-center gap-3 bg-[#322216]/95 border border-[#D4AF37]/40 rounded-full px-4 py-2 shadow-xl" data-testid="obstacle-modifier-bar">
      <Sparkles className="w-4 h-4 text-[#D4AF37] shrink-0" />
      <span className="text-xs text-[#f1e0c5]/80">{pending.token_name || "A player"} is about to roll: {pending.label} (DC {pending.dc})</span>
      <div className="flex items-center gap-1">
        <button data-testid="obstacle-modifier-minus" onClick={() => apply(modifier - 1)} className="w-6 h-6 rounded-full bg-black/40 text-[#f1e0c5]/70 hover:text-white transition-colors">−</button>
        <Input
          data-testid="obstacle-modifier-input"
          type="number"
          value={modifier}
          onChange={(e) => apply(parseInt(e.target.value, 10) || 0)}
          className="w-14 h-7 text-center bg-black/30 border-white/10 text-xs"
        />
        <button data-testid="obstacle-modifier-plus" onClick={() => apply(modifier + 1)} className="w-6 h-6 rounded-full bg-black/40 text-[#f1e0c5]/70 hover:text-white transition-colors">+</button>
      </div>
      <button data-testid="obstacle-modifier-dismiss" onClick={() => setPending(null)} className="text-[#f1e0c5]/40 hover:text-white text-xs">Dismiss</button>
    </div>
  );
}
